import API from '@/common/modules/api'

const colors = [
    '#1c9e3b',
    '#6bb518',
    '#a0da27',
    '#d4e843',
    '#f5d60f',
    '#ffae16',
    '#f37000',
    '#e6370c'
];

const icons = (() => {

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const ratio = devicePixelRatio || 1;

    canvas.width = 36 * ratio;
    canvas.height = 36 * ratio;
    canvas.style.width = 36 + 'px';
    canvas.style.height = 36 + 'px';

    ctx.scale(ratio, ratio);

    return colors.reduce((result, color) => {

        ctx.clearRect(0, 0, 36, 36);
        ctx.save();

        ctx.shadowColor = 'rgba(34,34,34,0.32)';
        ctx.shadowBlur = 6;
        ctx.shadowOffsetY = 4;
        ctx.fillStyle = '#fff';

        ctx.beginPath();
        ctx.arc(18, 14, 12, Math.PI / 3, 2 * Math.PI / 3, true);
        ctx.lineTo(18, 32);
        ctx.closePath();
        ctx.fill();
        ctx.restore();

        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc(18, 14, 8, 0, 2 * Math.PI, false);
        ctx.closePath();
        ctx.fill();

        result[color] = canvas.toDataURL();
        return result;


    }, {});


})();






export default {

    namespaced: true,

    state: {
        data: {},
        heatmap: null,
        hovered: {
            deal: false,
            building: false
        },
        request: {
            refresh: false,
            sort: false,
            more: false,
            heatmap: false
        }
    },

    getters: {

        pending (state) {
            return key => !!state.request[key];
        },

        clusters (state) {
            return state.data.map && state.data.map.clusters || [];
        },

        deals (state) {
            return state.data.deals || {};
        },

        buildings (state, getters) {
            return getters.deals.buildings || [];
        },

        building (state, getters) {
            return id => getters.buildings.find(building => building.id === id);
        },

        dealsLoaded (state, getters) {
            return getters.buildings.reduce((sum, building) => sum + building.deals.length, 0) === getters.deals.dealsCount;
        },

        chartPrices (state) {
            const chart = state.data.charts && state.data.charts.tradesAverage;
            if (chart && chart.chartLabels.length) return chart;
        },

        chartDeals (state) {
            const chart = state.data.charts && state.data.charts.tradesCount;
            if (chart && chart.chartLabels.length) return chart;
        },

        priceColors () {
            return colors;
        },

        priceRange (state, getters) {
            if (!getters.clusters.length) return [];
            const min = Math.min.apply(Math, getters.clusters.map(cluster => cluster.minPrice || cluster.averagePrice));
            const max = Math.max.apply(Math, getters.clusters.map(cluster => cluster.maxPrice || cluster.averagePrice));
            const step = (max - min) / getters.priceColors.length;
            return new Array(colors.length + 1).fill().map((_, i) => Math.round(min + i * step));
        },

        priceColor (state, getter) {
            return price => colors[getter.priceRange.findIndex(p => price <= p)] || colors[colors.length - 1];
        },

        priceIcon (state, getter) {
            return price => icons[getter.priceColor(price)];
        },

        heatPoints (state, getters, rootState) {
            return rootState.search.params.heatmap && state.heatmap && state.heatmap.points;
        },

        isHovered (state) {
            return object => Object.keys(object).map(key => state.hovered[key] === object[key]).every(Boolean);
        }

    },

    actions: {

        abort ({state}, keys = Object.keys(state.request)) {
            keys.forEach(key => state.request[key] && (state.request[key] = API.abort(state.request[key])));
        },

        hover ({state}, hovered) {
            state.hovered = {...state.hovered, ...hovered}
        },

        refresh ({state, dispatch, rootGetters}) {
            dispatch('abort');
            dispatch('heatmap');
            state.request.refresh = API('home', rootGetters['search/params']);
            state.request.refresh
                .then(response => state.data = response.data)
                .finally(() => state.request.refresh = false);
        },

        heatmap ({state, dispatch, rootState, rootGetters}) {
            dispatch('abort', ['heatmap']);
            if (!rootState.search.params.heatmap) return;
            state.request.heatmap = API('heatmap', rootGetters['search/params']);
            state.request.heatmap
                .then(response => state.heatmap = response.data)
                .finally(() => state.request.heatmap = false);
        },

        sort ({state, dispatch, rootGetters}) {
            dispatch('abort', ['more', 'sort']);
            state.request.sort = API('buildings', rootGetters['search/params']);
            state.request.sort
                .then(response => {
                    state.data.deals = response.data
                })
                .finally(() => state.request.sort = false);
        },

        more ({state, getters, rootGetters}) {
            if (state.request.more) return;
            if (getters.dealsLoaded) return;
            state.request.more = API('buildings', {...rootGetters['search/params'], skip: getters.deals.nextIndex});
            state.request.more
                .then(response => {
                    const prev = getters.buildings;
                    state.data.deals = response.data;
                    state.data.deals.buildings = prev.concat(getters.buildings);
                })
                .finally(() => state.request.more = false);
        }

    }

}
